"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var Image = function (_a) {
    var src = _a.src, className = _a.className;
    return (react_1.default.createElement("img", { src: src, className: classnames_1.default(classes_1.addClassName('background-image'), 'object-cover overflow-hidden w-full', className) }));
};
exports.Image = Image;
//# sourceMappingURL=image.js.map